export const USER_TABS = {
  ABOUT: 'aboutProduct',
  MAIN: 'main',
  LICENSES: 'licenses',
  CLASSIFIERS: 'classifiers',
  // KNOWLEDGE_BASE: 'knowledgeBase',

}
export const ADMIN_TABS = {
  ABOUT: 'aboutProduct',
  MAIN: 'main',
  CLIENTS: 'clients',
  CLASSIFIERS: 'classifiers',
}

export const RIGHT_TABS = {
  PROFILE: 'profile',
} as const

export const KNOWLEDGE_LINK = 'https://im-pulse.notion.site'
export const ABOUT_PROJECT_LINK = 'https://impulse.spbstu.ru/'
